<form [formGroup]="searchForm" class="flex relative header-site-search" (ngSubmit)="onSubmit()">
  <button
    [class.is-vishidden]="inputExpanded"
    [attr.aria-hidden]="inputExpanded ? true : false"
    (click)="expandSearch()"
    type="button"
    class="z0 site-search-expand flex flex--center search-button text-hover"
  >
    <span class="is-vishidden">{{ 'siteSearch.search' | finLocalization }}</span>
    <fcom-icon class="is-xsmall white-text" name="search"></fcom-icon>
    <span *ngIf="isShowSearchText" class="white-text font-body-1 pr-xxsmall-l search-button-text nowrap">{{
      'siteSearch.search' | finLocalization
    }}</span>
  </button>
  <input
    class="form-control ps-xxsmall font-body-1 flex-1 light-type ps-medium-r"
    [class.expanded]="inputExpanded"
    [attr.tabindex]="!inputExpanded ? -1 : null"
    [attr.aria-label]="'siteSearch.search' | finLocalization"
    [attr.aria-hidden]="inputExpanded ? false : true"
    (blur)="onBlur()"
    [placeholder]="'siteSearch.search' | finLocalization"
    #headerQueryField
    formControlName="searchKey"
  />
  <button
    [class.is-vishidden]="!inputExpanded"
    [attr.hidden]="inputExpanded ? null : true"
    type="submit"
    class="z0 absolute"
  >
    <span class="is-vishidden grey-80-text">{{ 'siteSearch.search' | finLocalization }}</span>
    <fcom-icon class="is-xsmall grey-80-text site-search-run" name="search"></fcom-icon>
    <span *ngIf="isShowSearchText" class="white-text font-body-1 pr-xxsmall-l search-button-text nowrap">{{
      'siteSearch.search' | finLocalization
    }}</span>
  </button>
</form>
